import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoanService } from '../../services/loan.service';
import { LoanActionTypes } from '../../store/actions/loan-actions';
import { ImageResolver, ShareDataRow } from '@alfresco/adf-content-services';
import { DataColumn } from '@alfresco/adf-core';
import { PipeServiceImpl } from 'pipe-service/pipe-service-impl';
import { UdeuService } from '../../services/udeu.service';
import { RENEWAL_ASPECT } from '../../model/contants/deusto';
import { hasAspect } from 'projects/alden-extension/src/lib/rules/alden.rules';

@Component({
    templateUrl: './loans.component.html',
    styleUrls: ['./loans.component.scss'],
})
export class LoansComponent implements OnInit, OnDestroy { 

    //Nombre de la confituración del visor en el json
    viewerConfigId: string = "deusto-loans-viewer";

    loading: boolean;

    constructor(private route: ActivatedRoute, private router: Router, private loanService: LoanService, 
        private udeuService: UdeuService, private pipeService: PipeServiceImpl) {
    }

    async ngOnInit(): Promise<void> {
        this.loading = true;

        const UUID = this.route.snapshot.paramMap.get('uuid');
        if(UUID) {
            // Eliminar el parámetro de la URL
            this.router.navigate(['../'], { relativeTo: this.route }); 
            // Abrimos la transferencia
            this.loanService.openLoanDialogComponent(UUID, LoanActionTypes.GrantLoan, true);
        }

        this.udeuService.getPersonDetails();
        await this.udeuService.getProfileState();
        this.loading = false;
    }
    
    ngOnDestroy(): void {
        // Necesitamos limpiar los maps por si han actualizado algún valor
        this.pipeService.refreshMaps();
    }
    
    customImageResolver: ImageResolver  = (row: ShareDataRow, col: DataColumn) => {
        if (col.id = "deusto-loans-viewer.renewal") {
            if(hasAspect(row.node, RENEWAL_ASPECT)) {
                return 'assets/deusto-extension/images/sync_problem.svg';
            }
        }
        return null;
    }; 
        
}